import React, { Component } from 'react';
import { observer } from 'mobx-react';
import SelectedElementWrapperUtil from './utils';
import selectedElementWithType from './selected-ele-wrapper-factory';
import { GroupUIEdge } from '../../element-types/group-element/constant';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ObserverFactory from '@src/slide/application/service/modelObserver/observerFactory';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ServicesContext } from '../context';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

interface SelectedElementOuterProps {
    element: IElementBaseModel;
    scale: number;
    selectedElementInGroupInMobile?: boolean;
}

@observer
class SelectedElementOuter extends Component<SelectedElementOuterProps> {
    public static contextType = ServicesContext;

    public componentDidMount() {
        const observer = ObserverFactory.createObserver(this.props.element);
        if (observer) {
            observer.addLocalChangeObserver(this.updateComponent);
            observer.addChangesetObserver(this.updateComponent);
        }
    }

    public updateComponent = () => {
        this.forceUpdate();
    };

    public componentWillUnmount() {
        const observer = ObserverFactory.createObserver(this.props.element);
        if (observer) {
            observer.removeLocalChangeObserver(this.updateComponent);
            observer.removeChangesetObserver(this.updateComponent);
        }
    }

    /* eslint-disable complexity */
    public render() {
        const elementModel = this.props.element;
        let frameInfoForOuter = SelectedElementWrapperUtil.frameInfoForOuter(elementModel, false);
        // console.log('elementModel -- selection', elementModel, frameInfoForOuter);
        const SelectedElementContainer = selectedElementWithType(elementModel.type);
        let rootGroupFrame = this.getRootGroupFrame(elementModel);
        frameInfoForOuter = this.getOuterFrameInfo(elementModel, frameInfoForOuter);
        // canvas模式 对坐标进行取整操作
        frameInfoForOuter = this.canvasRectFloor(frameInfoForOuter);
        rootGroupFrame = this.canvasRectFloor(rootGroupFrame);
        const editable = this.getEditable();
        const isMobileRotatingMode = this.getRotateElementHandler()?.isMobileRotatingMode ?? false;
        const {
            isControlValuesChanging,
            isDragging,
            isResizing,
            isRotating,
            isConnecting,
            isCroping,
        } = this.context.editingStateManager;

        const isPreview = this.isPreview();
        const canRotate = editable && !isResizing && !isDragging && !isCroping;
        const selectable = this.getSelectable(elementModel);
        return (
            <div
                style={{
                    ...(frameInfoForOuter as React.CSSProperties),
                    ...rootGroupFrame,
                    position: 'absolute',
                    pointerEvents: 'none',
                    transform: SelectedElementWrapperUtil.transformForOuter(elementModel),
                }}
                id={'selected-element-outer'}
            >
                {SelectedElementContainer && <SelectedElementContainer
                    {...this.props}
                    element={this.props.element as any}
                    selectedElementInGroupInMobile={!!this.props.selectedElementInGroupInMobile}
                    canRotate={canRotate}
                    isRotating={isRotating}
                    isDragging={isDragging}
                    isResizing={isResizing}
                    isControlValuesChanging={isControlValuesChanging}
                    isConnecting={isConnecting}
                    isMobileRotatingMode={isMobileRotatingMode}
                    resizeHorizontal={editable && !isDragging}
                    resizeVertical={editable && !isDragging}
                    isCroping={isCroping}
                    draggable={editable && !isCroping}
                    isPreview={isPreview}
                    editable={editable}
                    isSelected={true}
                    onBorderClick={this.handleBorderClick}
                    selectable={selectable}
                    canBeConnected={
                        editable && elementModel.type !== UIModelType.GROUP
                        && elementModel.type !== UIModelType.SMART_ART}
                    showSelectBorder={elementModel.type !== UIModelType.CONNECTOR}
                    borderDraggable={selectable && !isCroping}
                />}
            </div>
        );
    }

    private handleBorderClick = (e) => {
        if (this.isSpecialKey(e.nativeEvent)) { // shift/control/command按住时多选
            if (this.props.element?.selected) {
                const selectionService = this.getSelectionService();
                selectionService?.selectedElements.remove(this.props.element);
            }
        }
    };


    private isSpecialKey = e => e.metaKey || e.shiftKey || e.ctrlKey;

    private getSelectable(elementModel) {
        let selectable = elementModel.selectable
            && elementModel.currentEditState <= PPTEditorStateType.SELECTABLE;
        if (elementModel.isPlaceholder
            && !elementModel.isCustomPlaceholder
            && elementModel.currentEditState > PPTEditorStateType.EDITABLE) {
            selectable = false;
        }
        return selectable;
    }

    private isRootGroup(elementModel) {
        return elementModel.type === UIModelType.GROUP && elementModel.isRootGroup;
    }

    private isPreview() {
        return this.context.editorAnimPreviewManager?.isAnimPreviewing
            || this.getPreviewService()?.isPreview;
    }

    private getEditable() {
        return this.getUserPriviledgeService().pptEditorState === PPTEditorStateType.EDITABLE;
    }

    private getOuterFrameInfo(elementModel, frameInfoForOuter) {
        if (elementModel.type === UIModelType.TABLE) {
            if (this.context.editingStateManager.isResizing) {
                // eslint-disable-next-line no-param-reassign
                frameInfoForOuter = elementModel.getFrame?.().getFrameInfo(false);
            }
        }
        return frameInfoForOuter;
    }

    private getRootGroupFrame(elementModel) {
        const isRootGroup = this.isRootGroup(elementModel);
        let rootGroupFrame = {};
        if (isRootGroup) {
            const rect = elementModel.getFrame?.().getFrameInfo(!!elementModel.operationFrame);
            rootGroupFrame = {
                left: rect.left - GroupUIEdge,
                top: rect.top - GroupUIEdge,
                width: rect.width + (GroupUIEdge * 2),
                height: rect.height + (GroupUIEdge * 2),
            };
        }
        return rootGroupFrame;
    }

    // canvas模式下，为了与canvas坐标一致（component-wrapper进行了向下取整），需将left/top向下取整
    private canvasRectFloor(rect) {
        ['top', 'left'].forEach((prop) => {
            if (rect?.[prop]) {
                rect[prop] = Math.floor(rect[prop]);
            }
        });
        return rect;
    }

    private getUserPriviledgeService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .viewableServiceLayer.userPriviledgeService;
    }

    private getPreviewService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.previewService;
    }

    private getRotateElementHandler() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.rotateElementHandler;
    }

    private getSelectionService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .viewableServiceLayer?.selectionService;
    }
}

export default SelectedElementOuter;
